import { render, staticRenderFns } from "./staffPage.vue?vue&type=template&id=ec342c7c&scoped=true&"
import script from "./staffPage.vue?vue&type=script&lang=js&"
export * from "./staffPage.vue?vue&type=script&lang=js&"
import style0 from "./staffPage.vue?vue&type=style&index=0&id=ec342c7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec342c7c",
  null
  
)

export default component.exports